import Box from "@mui/material/Box";
import {
  GridFilterInputSingleSelect,
  GridFilterInputSingleSelectProps
} from "@mui/x-data-grid-pro";

export const CustomGridFilterInputSingleSelect = (props: GridFilterInputSingleSelectProps) => {
  return (
    <Box
      sx={{
        "& .MuiFormControl-root": {
          marginTop: 0
        }
      }}
    >
      <GridFilterInputSingleSelect {...props} />
    </Box>
  );
};
